const TaxDeductionsDocumentFactory = (props) => {
  let document = null;
  if (props?.interactiveDocument === "IR330C") {
    document = IR330C(props);
  } else if (props?.interactiveDocument === "KS2") {
    document = KS2(props);
  } else if (props?.interactiveDocument === "KS10") {
    document = KS10(props);
  } else if (props?.interactiveDocument === "DriverConsent") {
    document = DriverConsent(props);
  } else if (props?.interactiveDocument === "JoinUnion") {
    document = JoinUnion(props);
  }
  return document;
};

const IR330C = (props) => {
  const data = props;
  return {
    "IRD number": data ? data.IRDNumber : null,
    "First names": data ? data.firstName : null,
    "Family/surname": data ? data.surName : null,
    day: data ? data.day : null,
    month: data ? data.month : null,
    year: data ? data.year : null,
    "tax code": data ? data.taxCode : null,
    signatureContent: data ? (data.signatureContent !== "" ? data.signatureContent.slice(22) : data.signatureContent) : null,
  };
};

const KS2 = (props) => {
  const data = props;
  return {
    "1 dash": data ? data.kivimember_yes : null,
    "1 dash 2": data ? data.kivimember_no : null,
    "2 dash 1": data ? data.suspensionSaving_yes : null,
    "2 dash 2": data ? data.suspensionSaving_no : null,
    rate_reduction_yes: data ? data.rate_reduction_yes : null,
    rate_reduction_no: data ? data.rate_reduction_no : null,
    "ird 1": data ? data.IRDNumber : null,
    Mr: data ? data.Mr : null,
    Ms: data ? data.Ms : null,
    Mrs: data ? data.Mrs : null,
    Miss: data ? data.Miss : null,
    other: data ? data.Other : null,
    "name other": data ? data.nameTitle.toUpperCase() : null,
    "first names": data ? data.firstName.toUpperCase() : null,
    surnames: data ? data.surName.toUpperCase() : null,
    "street no": data ? data.streetNumber : null,
    "street address": data ? data.streetAddress.toUpperCase() : null,
    suburb: data ? data.subUrb.toUpperCase() : null,
    "town/city": data ? data.town.toUpperCase() : null,
    postcode: data ? data.postCode : null,
    "telephone 3": data ? data.telephone3 : null,
    "telephone 1": data ? data.telephone1 : null,
    "telephone 2": data ? data.telephone2 : null,
    "mobile 1": data ? data.mobile1 : null,
    "mobile 2": data ? data.mobile2 : null,
    "mobile 3": data ? data.mobile3 : null,
    "email 1": data ? data.email1.toUpperCase() : null,
    "email 2": data ? data.email2.toUpperCase() : null,
    "contribute 3.5%": data ? data.contribution3_5 : null,
    "contribute 4%": data ? data.contribution4 : null,
    "contribute 6%": data ? data.contribution6 : null,
    "contribute 8%": data ? data.contribution8 : null,
    "contribute 10%": data ? data.contribution10 : null,
    day: data ? data.day : null,
    month: data ? data.month : null,
    year: data ? data.year : null,
    signatureContent: data ? (data.signatureContent !== "" ? data.signatureContent.slice(22) : data.signatureContent) : null,
  };
};

const KS10 = (props) => {
  const data = props;
  return {
    interactiveDocument: "KS10",
    "ird 1": data ? data.ird1 : null,
    "ird 2": data ? data.ird2 : null,
    "ird 3": data ? data.ird3 : null,
    "ird 4": data ? data.ird4 : null,
    "ird 5": data ? data.ird5 : null,
    "ird 6": data ? data.ird6 : null,
    tick: data ? data.tick : null,
    "name other": data ? data.nameTitle.toUpperCase() : null,
    "first names": data ? data.firstName.toUpperCase() : null,
    surnames: data ? data.surName.toUpperCase() : null,
    "street no": data ? data.streetNumber : null,
    "street address": data ? data.streetAddress.toUpperCase() : null,
    suburb: data ? data.subUrb.toUpperCase() : null,
    "town/city": data ? data.town.toUpperCase() : null,
    postcode: data ? data.postCode : null,
    "telephone 3": data ? data.telephone3 : null,
    "telephone 1": data ? data.telephone1 : null,
    "telephone 2": data ? data.telephone2 : null,
    "mobile 1": data ? data.mobile1 : null,
    "mobile 2": data ? data.mobile2 : null,
    "mobile 3": data ? data.mobile3 : null,
    "email 1": data ? data.email1.toUpperCase() : null,
    "email 2": data ? data.email2.toUpperCase() : null,
    bank: data ? data.bank.toUpperCase() : null,
    branch: data ? data.bankBranch.toUpperCase() : null,
    suffix: data ? data.bankSuffix.toUpperCase() : null,
    account: data ? data.bankAccountNumber : null,
    "account holder name": data ? data.bankAccountHolder.toUpperCase() : null,
    day: data ? data.eday : null,
    month: data ? data.emonth : null,
    year: data ? data.eyear : null,
    "7 day": data ? data.day : null,
    "7 month": data ? data.month : null,
    "7 year": data ? data.year : null,
    "employers business name 1": data ? data.businessName1.toUpperCase() : null,
    "employers business name 2": data ? data.businessName2.toUpperCase() : null,
    "reason for late opt-out request": data ? data.leftoutReason : null,
    signatureContent: data ? (data.signatureContent !== "" ? data.signatureContent.slice(22) : data.signatureContent) : null,
    "leftoutReason" : data ? data.leftoutReason : null,
  };
};

const DriverConsent = (props) => {
  const data = props;
  return {
    interactiveDocument: "DriverConsent",
    licenceholdername: data.licenceholdername,
    companyname: data.companyname,
    driverlicencenumber: data.driverlicencenumber,
    driverlicenceversion: data.driverlicenceversion,
    licenceholderdob: data.licenceholderdob,
    periodmonth: data.periodmonth,
    perioddate: data.perioddate,
    employmentduration: data.employmentduration ? "1" : "0",
    signatureContent : data ? (data.signatureContent !== "" ? data.signatureContent.slice(22) : data.signatureContent) : null,
    signaturedate:  data.signaturedate
  };
};

const JoinUnion = (props) => {
  var data =  props;

  return {
    interactiveDocument: "JoinUnion",
    fullname: data.fullname, 
    occupation: data.occupation,
    yesjoin: data.yesjoin ? "1" : "0",
    email: data.email,
    phone: data.phone,
    role: data.role,
    unionname: data.unionname,
    donotpass: data.donotpass ? "2" : "0",
    nojoin: data.nojoin ? "3" : "0",
    nojoinnopass: data.nojoinnopass ? "4" : "0",
    day: data.day,
    month: data.month,
    year: data.year,
    signatureContent: data ? (data.signatureContent !== "" ? data.signatureContent.slice(22) : data.signatureContent) : null,
  };
};

export default TaxDeductionsDocumentFactory;
